import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { AddVendor, UpdateVendor, DeleteVendor, GetVendorList } from 'services/vendor/vendor.service';
import { GetPermissions } from 'services/user/user.service';
import { Table } from 'components/Table/Table';
import { NameColumn} from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import { VendorValidationSchema } from 'utilities/ValidationSchema/VendorValidationSchema';
import duplicateNameChecker from 'utilities/duplicateNameChecker';

const Vendor = () => {
    const { permissionList } = useSelector((state) => state.permissionList);
    const { vendorAdd, vendorAddLoading } = useSelector((state) => state.vendorAdd);
    const { vendorUpdate, vendorUpdateLoading } = useSelector((state) => state.vendorUpdate);
    const { vendorList, vendorListLoading } = useSelector((state) => state.vendorList);

    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [duplicateNameExist, setDuplicateNameExist] = useState(false);

    const [selectedData, setSelectedData] = useState([])

    const dispatch = useDispatch();

    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        name: "",
        contact_person: "",
        phone: "",
        email: "",
        address: "",
    };

    const updateInitialValue = {
        ...updateData,
    };
    

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: VendorValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit(values);
        },
        enableReinitialize: true,
    });

    const editBrand = (product) => {
        setShowForm(true); // * set the form to true
        setUpdateData(product);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteVendor(id));
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetVendorList());
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (data) => {
        if(updateData){
            await dispatch(UpdateVendor(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddVendor(data)).then(() => {
            hideModal();
            return
        });
    };

    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetVendorList());
    }, [vendorAdd, vendorUpdate]);

    useEffect(() => {
        dispatch(GetPermissions());
        dispatch(GetVendorList());
    }, []);


    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "Name", sortableBody: NameColumn },
        { field: "contact_person", header: "Contact person", sortableBody: NameColumn },
        { field: "phone", header: "Phone", sortableBody: NameColumn },
        { field: "email", header: "Email", sortableBody: NameColumn },
        { field: "address", header: "Address", sortableBody: NameColumn },
    ];

    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "name",
            name: "name",
            type: "text",
            labelFor: "Name",
            label: "Enter a Name",
            required: true,
            className: "col-12 md:col-12",
            onBlur: (e) => duplicateNameChecker(e.target.value, vendorList, updateData, setDuplicateNameExist),
        },
        {
            id: "contact_person",
            name: "contact_person",
            value: "contact_person",
            type: "text",
            labelFor: "contact_person",
            label: "Contact Person",
            required: true,
            className: "col-12 md:col-12",
        },
        {
            id: "phone",
            name: "phone",
            value: "phone",
            type: "text",
            labelFor: "phone",
            label: "Phone",
            required: true,
            messagePosition: 'bottom',
            className: "col-12 md:col-12",
        },
        {
            id: "email",
            name: "email",
            value: "email",
            type: "text",
            labelFor: "email",
            label: "Email",
            required: false,
            messagePosition: 'toast',
            className: "col-12 md:col-12",
        },
        {
            id: "address",
            name: "address",
            value: "address",
            type: "text",
            labelFor: "address",
            label: "Address",
            required: true,
            messagePosition: 'bottom',
            className: "col-12 md:col-12",
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editBrand(rowData)} />
                <Toast ref={toast} />
                <ConfirmPopup />
                <Button 
                    onClick={(e) => {
                        DeleteModal(e, rowData.id);
                    }} 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-warning mt-2"
                />
            </div>
        );
    }


    return (
        <>
            <Table
                tableHeaderName="Vendors"
                tableColumns={tableColumns}
                data={vendorList}
                loading={vendorListLoading}
                dataKey="id"
                rows={25}
                toolbarPermissions={permissionList[0]}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <CreateModal 
                dialogVisible={showForm} 
                column={12} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={`${!updateData ? "Create" : "Update "} Vendor`} 
                modalWidth="500px" 
                reset={resetForm} 
                btnLoading={vendorAddLoading || vendorUpdateLoading} 
                update={updateData} 
                disabled={duplicateNameExist}
                col1={5}
                col2={updateData ? 3 : 4}
                col3={4}
            />
        </>
    );
};

export default Vendor;
